import { USER_DEVICE, USER_TAG } from '@base/constants'
import storage from '@base/utils/storage'
import type { Method } from '@fe/typings'
import axios from 'axios'
import { LOCALSTORAGE_TOKENINFO } from '../config'
import { getClientEnv, isAndroid, isIos } from './browser'
import { getUrlParams } from './index'
import toast from './ui/toast'
import { redirectLogin } from './user'
/** 基础header 配置 */
let baseHeader = {
  'content-type': 'application/json;charset=UTF-8',
}
/** 基础的 请求配置
 * 可自定义其他的配置， cors_mode、credentials、cache 等
 */
const baseConfig = {
  dataType: 'json',
  timeout: 60000,
}

export const ERROR_MESSAGE = '网络异常，请稍后重试'
/** 通用请求 */
const fetchRequest = <T>(
  type: Method,
  /** 请求地址 */
  url: string,
  /** 请求数据 */
  requestData?: PassExtParamsDescriptorMore,
  /** 请求 header 数据 */
  headers?: Record<string, any>,
  /** 请求其他配置 */
  config?: Record<string, any>
): Promise<T> => {
  const { showLoading = false, showToast = false, fullResponse } = requestData || {}
  const device = storage.get(USER_DEVICE)
  const tagInfo = storage.get(USER_TAG) || []

  if (device) {
    baseHeader = Object.assign(baseHeader, {
      OsVersion: `web_h5_${isIos ? 'ios' : isAndroid ? 'android' : 'unknown'}`, // DOTO 后续需要兼容 其他小程序的可能会改} )
      AppVersion: '', //
    })
  }

  // 判断是否为客户端，是则在header中加上AppVersion参数
  const env = getClientEnv()
  const env2 = getClientEnv(true)
  // const secEnv = env === 'client' ? env : env2
  if (env === 'client') {
    baseHeader = Object.assign(baseHeader, {
      appVersion: window.sr.client.getVersion(),
    })
  } else if (env === 'mini') {
    baseHeader = Object.assign(baseHeader, {
      appVersion: getUrlParams(window.location.href, 'version'),
    })
  } else {
    baseHeader = Object.assign(baseHeader, {
      appVersion: '1.2.6',
    })
  }

  delete headers?._description
  delete headers?._gateway
  delete headers?._method

  /** header 合并数据 */
  const mergeHeader = Object.assign(baseHeader, headers.headers)

  // 单独重新获取 accessToken
  const info = window?.sr?.userInfo || storage.get<API_PostAccountMobileLogin.AccountInfo>(LOCALSTORAGE_TOKENINFO)

  mergeHeader.accesstoken = info?.tokenInfo?.accessToken || ''
  // mergeHeader.tag = base64 || ''

  mergeHeader.device = `${isIos ? 'ios' : isAndroid ? 'android' : 'unknown'}${info?.openId ? '-' + info?.openId : ''}` //  新增openid 为device

  mergeHeader.mobile = info?.mobile || ''
  mergeHeader.container = env2 === 'web' ? 'h5' : env2
  mergeHeader.UserSystem = 'H5'
  /** 合并配置数据 */
  const mergeConfig = Object.assign(baseConfig, config)
  /** 发送请求 */

  const axiosParams: { url: string; [propsName: string]: any } = {
    ...mergeConfig,
    url,
    method: type,
    headers: {
      ...mergeHeader,
      'Referrer-Policy': 'origin',
    },
  }

  // ios11 & 12 bug
  // @see https://github.com/axios/axios/issues/3192
  if (type === 'GET') {
    axiosParams.params = requestData
    axiosParams.data = undefined
  } else if (type === 'POST') {
    axiosParams.params = undefined
    axiosParams.data = requestData
  }

  return axios(axiosParams)
    .then((result) => {
      const { data } = result

      console.log('result', result)
      if (fullResponse) return data

      const { success, code, responseHead } = data

      if (success || code === 0 || code === 200) {
        if (code === 500) {
          toast.error(data.data)
        }

        return data.data
      } else if (responseHead && responseHead.isSuccess) {
        // 兼容 app bff
        return data
      } else {
        if (code === 20005) {
          redirectLogin(window.location.reload.bind(window.location))

          return
        }

        console.log('errSuccess', data)
        toast.show({
          content: data?.msg || data?.data || data?.message || responseHead?.resultMessage || ERROR_MESSAGE,
        })
      }
    })
    .catch((err) => {
      const result = err.response || {}
      const { data, status } = result

      if (status === 403) {
        return data
      }

      if (status === 401) {
        redirectLogin(window.location.reload.bind(window.location))
        return
      }

      console.log('error', err)
      toast.error(data?.error || data?.data?.msg || data?.data?.message || data?.data?.responseHead || ERROR_MESSAGE)
    })
}

/** get 请求 */
const getApi = <T>(
  /** 请求地址 */
  url: string,
  /** 请求数据 */
  requestData?: PassExtParamsDescriptorMore,
  /** 请求 header 数据 */
  headers?: Record<string, any>,
  /** 请求其他配置 */
  config?: Record<string, any>
): Promise<T> => {
  return fetchRequest('GET', url, requestData, headers, config)
}

/** post 请求 */
const postApi = <T>(
  /** 请求地址 */
  url: string,
  /** 请求数据 */
  requestData?: PassExtParamsDescriptorMore,
  /** 请求 header 数据 */
  headers?: Record<string, any>,
  /** 请求其他配置 */
  config?: Record<string, any>
): Promise<T> => {
  return fetchRequest('POST', url, requestData, headers, config)
}

export default {
  getApi,
  postApi,
  fetchRequest,
}
